<ideal-product-not-returnable-view [returnable]="returnable()" [line]="line()" />
